import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import { vacancySettingsResource, vacancyListResource } from '@/services/vacancy.service'

// Vacancy catalog — settings + list from API

export default /*@__PURE__*/_defineComponent({
  __name: 'Catalog',
  setup(__props, { expose: __expose }) {
  __expose();

const loading = ref(true)
const settings = ref<{
  bannerImage?: string
  companyDescription?: string
} | null>(null)
const vacancyList = ref<any[]>([])

// Фікс Mixed Content: якщо сторінка HTTPS, а API повертає HTTP — підміняємо протокол
const bannerSrc = computed(() => {
  const url = settings.value?.bannerImage
  if (!url) return ''
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && url.startsWith('http://')) {
    return url.replace('http://', 'https://')
  }
  return url
})

onMounted(async () => {
  try {
    const [settingsRes, listRes] = await Promise.all([
      vacancySettingsResource.execute({}),
      vacancyListResource.execute({}),
    ])
    // Settings: API returns { code, data: { item: {...} } }, camelCase keys
    settings.value = settingsRes?.data?.item ?? settingsRes?.data ?? settingsRes ?? null
    // List: API returns { code, data: { items: [...] } }
    vacancyList.value = listRes?.data?.items ?? listRes?.results ?? (Array.isArray(listRes) ? listRes : [])
  } catch (e) {
    console.error('Vacancy catalog load error:', e)
  } finally {
    loading.value = false
  }
})

const __returned__ = { loading, settings, vacancyList, bannerSrc, ref, computed, onMounted, get vacancySettingsResource() { return vacancySettingsResource }, get vacancyListResource() { return vacancyListResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})